module.exports = __webpack_public_path__ + "img/CV.Pavement.Non_trafficked_pavement_or_footpath.Type_F2_Footway,_poor_exisitng_ground.4fe7b3e0.png";